import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { momentDate } from 'util/dateTime';

export default function UpcomingCandidateEventCalendar({
  date,
}: {
  date: string;
}) {
  return (
    <Box bgcolor="mono0" bw={1} w={54} bcolor="mono300" bradiuss>
      <Box bgcolor="mono100" tcenter>
        <Text variant="bodySm" capitalize>
          {momentDate(date).format('ddd').toUpperCase()}
        </Text>
      </Box>
      <Box flex alignItemsCenter justifyContentCenter column>
        <Text variant="bodySmBold" color="mono900">
          {momentDate(date).format('D').toUpperCase()}
        </Text>
        <Box bt={1} bcolor="mono300">
          <Text variant="bodySm" color="mono900">
            {momentDate(date).format('MMM').toUpperCase()}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
